module.exports = __webpack_public_path__ + "img/logo_colored.d84d23d1.png";